import { initAutoLc } from '@/locales/ko/views/user_permission_setting_dialog';
const lc = initAutoLc('table_header.');
export const userPermissionSettingTableHeader = [
    {
        title: lc('category'),
        align: 'start',
        value: 'item.depth2Name',
        width: 150,
    },
    {
        title: lc('permission_name'),
        align: 'start',
        value: 'item.name',
        width: 260,
    },
    {
        title: lc('permission_code'),
        align: 'center',
        value: 'item.code',
        width: 90,
    },
    {
        title: lc('use_yn'),
        align: 'center',
        value: 'item.isAuthorized',
        width: 220,
    },
    {
        title: lc('hint'),
        align: 'start',
        value: 'item.hint',
    },
    {
        title: '',
        align: 'end',
        key: 'data-table-expand',
        width: 70,
    },
];
